var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCreditCard = function SvgIconCreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.766,
    height: 22.061,
    viewBox: "0 0 27.766 22.061",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1279",
    "data-name": "Group 1279",
    transform: "translate(-252.237 -522.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    d: "M274.359,529.709l-.562-6.7a.5.5,0,0,0-.539-.452l-20.037,1.778a.5.5,0,0,0-.451.539l1.024,11.535a.5.5,0,0,0,.539.451l3.049-.27",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#434342",
    strokeMiterlimit: 10,
    strokeWidth: 1.058
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    d: "M282.482,540.864h3.061a.5.5,0,0,1,.5.5v11.58a.5.5,0,0,1-.5.5H265.426a.5.5,0,0,1-.5-.5v-11.58a.5.5,0,0,1,.5-.5Z",
    transform: "translate(-6.565 -9.882)",
    fill: "none",
    stroke: "#434342",
    strokeMiterlimit: 10,
    strokeWidth: 1.058
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1277",
    "data-name": "Group 1277",
    transform: "translate(260.026 533.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    d: "M272.1,547.047h-2.98c-.1,0-.189.049-.189.11v1.476c0,.061.085.11.189.11h2.98c.1,0,.189-.049.189-.11v-1.476C272.286,547.1,272.2,547.047,272.1,547.047Z",
    transform: "translate(-268.75 -547.047)",
    fill: "#434442"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1275",
    "data-name": "Group 1275",
    transform: "translate(0 2.724)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u2022\\u2022\\u2022\\u2022",
    transform: "translate(0 1)",
    fill: "#434342",
    fontSize: 1,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2022\u2022\u2022\u2022")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "\\u2022\\u2022\\u2022\\u2022",
    transform: "translate(4.744 1)",
    fill: "#434342",
    fontSize: 1,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2022\u2022\u2022\u2022")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": "\\u2022\\u2022\\u2022\\u2022",
    transform: "translate(9.488 1)",
    fill: "#434342",
    fontSize: 1,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2022\u2022\u2022\u2022")), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": "\\u2022\\u2022\\u2022\\u2022",
    transform: "translate(14.232 1)",
    fill: "#434342",
    fontSize: 1,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2022\u2022\u2022\u2022"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1276",
    "data-name": "Group 1276",
    transform: "translate(0.117 5.929)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "NOME_SOBRNOME",
    "data-name": "NOME SOBRNOME",
    fill: "#434442",
    fontSize: 2,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2
  }, "NOME ")), /*#__PURE__*/React.createElement("text", {
    id: "MM_AA",
    "data-name": "MM/AA",
    transform: "translate(14.306 0.014)",
    fill: "#434442",
    fontSize: 2,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2
  }, "M")))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    d: "M260.9,528.592l-2.971.234c-.1.008-.184.064-.179.125l.116,1.472c.005.06.093.1.2.095l2.97-.235c.1-.008.185-.064.18-.124l-.116-1.472C261.094,528.626,261.006,528.583,260.9,528.592Z",
    transform: "translate(-2.691 -3.258)",
    fill: "#434442"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1278",
    "data-name": "Group 1278",
    transform: "translate(255.546 527.38)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": "\\u2022\\u2022\\u2022\\u2022",
    transform: "translate(0.079 2.406) rotate(-4.51)",
    fill: "#434342",
    fontSize: 1,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2022\u2022\u2022\u2022")), /*#__PURE__*/React.createElement("text", {
    id: "_6",
    "data-name": "\\u2022\\u2022\\u2022\\u2022",
    transform: "translate(4.808 2.032) rotate(-4.51)",
    fill: "#434342",
    fontSize: 1,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2022\u2022\u2022\u2022")), /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": "\\u2022\\u2022\\u2022\\u2022",
    transform: "translate(9.537 1.659) rotate(-4.51)",
    fill: "#434342",
    fontSize: 1,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2022\u2022\u2022\u2022")), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": "\\u2022\\u2022\\u2022\\u2022",
    transform: "translate(14.267 1.286) rotate(-4.51)",
    fill: "#434342",
    fontSize: 1,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u2022\u2022\u2022\u2022"))), /*#__PURE__*/React.createElement("text", {
    id: "NOM",
    transform: "translate(255.954 531.971) rotate(-4.51)",
    fill: "#434442",
    fontSize: 2,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 2
  }, "NOM")))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_credit_card.5292d197.svg";
export { ForwardRef as ReactComponent };